<template>
  <div>
    <div class="launch-content" v-show="isShowList">
      <Ad activeType="materialCreative" @setSdkProviderList="setSdkProviderList" >
        <div slot="materialCreative" class="page-container">
          <div class="tab-list">
            <div
                v-for="(item, index) in tabList"
                :key="index"
                :class="['tab-item', index === tabIndex ? 'active' : '']"
                @click="tabIndex = index"
              >
                <span :title="item.content">{{ item.content }}</span>
            </div>
          </div>
          <div class="content-table">
            <List v-if="tabIndex === 0" ref="list" @create="handleCreate" @edit="handleEdit"></List>
            <MaterialCreativeThirdList v-if="tabIndex === 1" ref="thirdList" @create="handleCreate" @edit="handleEdit" />
          </div>
        </div>
      </Ad>
    </div>
    <div v-if="!isShowList && mode !=='read'">
      <Add :mode="mode" :id="id" :planType="planType" :sdkProviderList="sdkProviderList" :materiaObj="materiaObj" @go-back="handleGoBack"></Add>
    </div>
  </div>
</template>
<script>
import Ad from '@/components/Ad'
import List from './MaterialCreativeList'
import MaterialCreativeThirdList from './MaterialCreativeThirdList.vue'
import Add from './MaterialCreativeAdd'
import { computed } from 'vue'
export default {
  components: {
    Ad,
    List,
    Add,
    MaterialCreativeThirdList
  },
  data() {
    return {
      isShowList: true,
      id: undefined,
      mode: 'create',
      materiaObj: {},
      tabIndex: 0,
      tabList: [
        { content: '展示量合约' },
        { content: '程序化采买' }
      ],
      planType: 0,
      sdkProviderList: [],
      eventTempList: [],
    }
  },
  provide() {
    return {
      eventTempList: computed(() => this.eventTempList)
    }
  },
  methods: {
    setSdkProviderList(e) {
      this.sdkProviderList = e || []
    },
    // quickSearch() {
    //   this.$refs.list.fetchDataDebounced()
    // },
    handleCreate(planType) {
      this.isShowList = false
      this.mode = 'create'
      this.planType = planType
      this.id = undefined
    },
    handleEdit(item) {
      this.id = item.mediaId
      this.materiaObj = item
      this.mode = 'edit'
      this.isShowList = false
    },
    handleGoBack() {
      this.isShowList = true
      this.mode = 'list'
      this.$nextTick(() => {
        this.tabIndex === 0 ? this.$refs.list.fetchData() : this.$refs.thirdList.fetchData()
      })
    }
  },
  async created() {
    this.eventTempList = await this.$service.getTargetTemp({})
  },
  activated() {
    if (this.$route.params.add) {
      this.handleCreate()
    }
  }
}
</script>
<style lang="stylus" scoped>
.page-container
  display flex
  flex-flow row nowrap
.tab-list
  padding 8px 0
  border-right 1px solid #eee
  width 130px
.content-table
  width calc(100% - 130px)
.tab-item
  padding 0 20px
  line-height 50px
  height 50px
  font-size 14px
  color #000000A6
  white-space nowrap
  overflow hidden
  text-overflow ellipsis
  cursor pointer
  &:hover
    background-color #fffaf3
    color #ff8b00
  &.active
    border-left 2px solid #ff8b00
    background-color #fffaf3
    color #ff8b00
</style>
